import { Injectable } from '@angular/core';
import * as Airtable from 'airtable';
import { environment } from '../../environments/environment';
import { from, of } from 'rxjs';
import { Announcement } from './announcement.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export default class AirtableService {
  airtable = new Airtable({
    endpointUrl: `https://api.airtable.com`,
    apiKey: environment.airtable.apiKey,
  });

  getActiveAnnouncement() {
    return from(
      this.airtable
        .base(environment.airtable.base)
        .table('Announcements')
        .select()
        .all()
    ).pipe(getSingleActiveAnnouncementRecord(), mapRecordToAnnouncement());
  }
}

const getSingleActiveAnnouncementRecord = () => {
  return map((announcements: AirtableRecord<AnnouncementRecord>[]) => {
    if (!announcements.length) {
      return of(null);
    }
    return announcements.filter(
      (announcement) => announcement.fields.Active === true
    )[0];
  });
};

const mapRecordToAnnouncement = () => {
  return map(
    (record: AirtableRecord<AnnouncementRecord>) =>
      ({
        id: record?.id,
        details: record?.fields.Details,
        active: record?.fields.Active,
        title: record?.fields.Title,
      } as Announcement)
  );
};

interface AirtableRecord<T> {
  id: string;
  fields: T;
}

interface AnnouncementRecord {
  Details: string;
  Active: boolean;
  Title: string;
}
